<template>
  <div>
    <section class="page-inbound" :class="{'rtl': locale === 'ar', 'qd-app': qdApp}" v-if="!loading">
      <section class="stepQuote">
        <div class="containerMini">
          <slot name="logo">
            <Logo @click="$emit('clickLogo')">
              <template v-if="$slots['logo-first-line']" #logo-first-line>
                <slot name="logo-first-line"></slot>
              </template>

              <template v-if="$slots['logo-second-line']" #logo-second-line>
                <slot name="logo-second-line"></slot>
              </template>
            </Logo>
          </slot>
          <div class="boxForm paymentForm" v-if="!error"> <!-- paymentFORM ADD-->
            <form action="#" class="boxForm_step6" @submit.prevent>
              <div class="successSent" v-show="notificationShow" @click="hideNotification()">
                <span>{{ $t('qic_insurance_success_policy_sent') }}</span>
                <i class="check"></i>
              </div>
              <div class="insurance">
                <img
                  v-if="!whoWillWin && !qdApp"
                  :src="img"
                  alt="bag"
                  class="ins-img-desc">
                <h1>{{ title || $t('qic_insurance_success_header') }}</h1>
                <div v-if="email" class="insuranceSendMail">
                  <div>{{ $t('qic_insurance_success_email_sent') }}</div>
                  <p v-if="!qdApp">{{ email }}</p>
                </div>

                <div v-if="qdApp" class="info">
                  <div class="info__header" :class="{'info__header_mobile': isMobile || width < 768}">
                    {{ $t('qic_insurance_success_qdApp_header') }}
                  </div>

                  <div v-if="width > 767" class="info__desc">{{ $t('qic_insurance_success_qdApp_desc') }}</div>
                  <div class="info__links">
                    <div v-if="!isMobile || width > 767" class="info__qr">
                      <QRcode />
                    </div>

                    <a :href="getAppLink('app-store')" target="_blank" class="info__app-store">
                      <ApplePay :locale="locale" />
                    </a>
                    <a :href="getAppLink('google-play')" target="_blank" class="info__google-play">
                      <GooglePlay :locale="locale" />
                    </a>
                  </div>
                </div>

                <a v-if="link" :href="link" target="_blank" class="btn btnInsSuc" type="button">
                  <svg v-if="!isMobile || width > 767" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 21H17.5C18.6046 21 19.5 20.1046 19.5 19V15.2083V9.05823C19.5 9.03879 19.4997 9.01938 19.4992 9H13.5H12.5V8V3H6.5C5.39543 3 4.5 3.89543 4.5 5V12V19C4.5 20.1046 5.39543 21 6.5 21ZM14.5 3.27114V7H18.2786L14.9179 3.59506C14.7924 3.46794 14.6517 3.35938 14.5 3.27114ZM6.5 1C4.29086 1 2.5 2.79086 2.5 5V12V19C2.5 21.2091 4.29086 23 6.5 23H17.5C19.7091 23 21.5 21.2091 21.5 19V15.2083V9.05823C21.5 8.00642 21.0857 6.99693 20.3469 6.24835L16.3413 2.19012C15.5897 1.42864 14.5644 1 13.4945 1H6.5Z" fill="#F1F4F6"/>
                  </svg>
                  {{ $t('qic_insurance_success_download_policy') }}
                </a>
                <template v-if="receipt">
                  <a v-if="!qdApp" :href="receipt" target="_blank" class="btn-ghost" type="button">
                    {{ $t('qic_insurance_receipt') }}
                  </a>
                  <a v-else :href="receipt" target="_blank" class="btn-ghost" type="button">
                    {{ $t('qic_insurance_qdApp_receipt') }}
                  </a>
                </template>
                <div
                  v-if="whoWillWin && !qdApp"
                  class="whollwin"> <!-- #TODO: Delete after fifa 2022 -->
                  <div class="whollwin__top">
                    <svg width="69" height="26" viewBox="0 0 69 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="68.5714" height="26" rx="13" fill="url(#paint0_linear_2062_16261)"/>
                      <path d="M37.9221 16.05H30.7926V15.8314C30.7926 15.8026 30.8034 15.7748 30.8229 15.7536C30.8423 15.7323 30.869 15.719 30.8978 15.7163L32.4348 15.4416V7.22984L30.8978 6.95589C30.8689 6.953 30.8423 6.93956 30.8228 6.91816C30.8034 6.89675 30.7926 6.86892 30.7926 6.84005V6.62148H37.9236V6.84005C37.9235 6.86892 37.9127 6.89675 37.8933 6.91816C37.8739 6.93956 37.8472 6.953 37.8184 6.95589L36.2814 7.22984V15.4387L37.8184 15.7134C37.8471 15.7161 37.8738 15.7294 37.8933 15.7507C37.9127 15.772 37.9235 15.7997 37.9236 15.8285L37.9221 16.05ZM60.5424 13.1561C59.7756 13.5867 55.905 15.8321 50.1364 15.8321C44.8435 15.8321 43.5592 12.9739 43.5592 11.3361C43.5592 9.69824 44.8129 6.83932 50.1364 6.83932C54.6506 6.83932 55.7174 7.31581 55.7174 7.31581C55.7398 7.32128 55.7633 7.31858 55.7838 7.30821C55.8042 7.29784 55.8205 7.28048 55.8294 7.25926C55.8382 7.23805 55.8389 7.21438 55.8318 7.19255C55.8246 7.17071 55.81 7.15215 55.7902 7.14022C55.7902 7.14022 53.5056 6.00146 50.133 6.00146C42.4581 6.00146 39.7044 9.02578 39.7044 11.3361C39.7044 13.6464 42.4564 16.67 50.133 16.67C53.973 16.67 58.1801 15.0802 60.5649 13.1947C60.5683 13.191 60.5707 13.1863 60.5714 13.1813C60.5717 13.1763 60.5707 13.1713 60.5683 13.1669C60.5656 13.1626 60.5618 13.1592 60.5571 13.1572C60.5523 13.1553 60.5472 13.1549 60.5424 13.1561ZM40.596 19.8262C35.0276 21.9718 31.4739 19.9646 28.1121 18.0375C26.0676 16.8718 23.7018 16.4128 22.4583 16.3356C27.1052 15.4875 28.87 13.1838 28.87 11.3346C28.87 9.02432 26.1158 6 18.4284 6C15.1499 6.03716 12.7834 7.13658 12.7834 7.13658C12.7619 7.14796 12.7456 7.16704 12.7376 7.18998C12.7296 7.21291 12.7306 7.23801 12.7404 7.26024C12.7502 7.28246 12.7681 7.30017 12.7904 7.3098C12.8127 7.31943 12.8379 7.32028 12.8608 7.31216C12.8608 7.31216 14.0576 6.84806 18.427 6.83641C23.7624 6.83641 25.0154 9.69532 25.0154 11.3332C25.0154 12.971 23.7624 15.8292 18.4255 15.8292C13.1018 15.8292 11.8481 12.971 11.8481 11.3332H8C8 13.6012 10.6542 16.5563 18.0108 16.6642C20.3656 16.6642 23.8727 17.9916 26.2363 19.2746C29.0248 20.7886 34.5552 24.2384 40.6135 19.8575C40.6155 19.8544 40.6166 19.8508 40.6167 19.8471C40.6168 19.8435 40.6159 19.8398 40.6141 19.8366C40.6123 19.8334 40.6097 19.8308 40.6065 19.8289C40.6033 19.8271 40.5997 19.8261 40.596 19.8262Z" fill="white"/>
                      <defs>
                        <linearGradient id="paint0_linear_2062_16261" x1="8.78571e-07" y1="2.76061" x2="69.7857" y2="17.401" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#661AA0"/>
                          <stop offset="1" stop-color="#D408A3"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <p>{{ $t('www_banner_in_insured.name') }}</p>
                  </div>
                  <p class="whollwin__desc">{{ $t('www_banner_in_insured.desc') }}</p>
                  <a :href="`/win?utm_source=qic&lang=${locale_}`" target="_blank" class="whollwin__btn">{{ $t('www_banner_in_insured.button') }}</a>
                </div>
              </div> <!-- insurance -->
            </form>
          </div> <!-- boxForm -->
          <BaseError v-else :message="error" @reload="onReload"/>
        </div> <!-- containerMini -->
      </section> <!-- stepQuote -->
      <RateService v-if="!error" />
    </section>
    <RedirectLoader v-if="loading"/>
  </div>
</template>

<script>
import Logo from './Logo.vue'
import RateService from './RateService.vue'
import RedirectLoader from './RedirectLoader'
import BaseError from './errors/BaseError'
import GooglePlay from './qdApp/GooglePlay'
import ApplePay from './qdApp/ApplePay'
import QRcode from './qdApp/successPage/QRcode'
import { isMobile } from 'mobile-device-detect'
export default {
  name: 'BaseInsuranceSuccess',
  props: [
    'img',
    'img-mobile',
    'link',
    'receipt',
    'email',
    'title',
    'locale',
    'loading',
    'error',
    'whoWillWin',
    'qdApp'
  ],
  data () {
    return {
      notificationShow: false,
      width: 0
    }
  },
  created () {
    window.addEventListener('resize', this.updateWidth)
    this.updateWidth()
  },
  destroyed () {
    window.removeEventListener('resize', this.updateWidth)
  },
  components: {
    Logo,
    RateService,
    RedirectLoader,
    BaseError,
    GooglePlay,
    ApplePay,
    QRcode
  },
  computed: {
    isMobile () {
      return isMobile
    },
    locale_ () {
      if (this.locale) return this.locale
      return 'en'
    }
  },
  methods: {
    updateWidth () {
      this.width = window.innerWidth
    },
    getAppLink (app) {
      if (this.isMobile) {
        return 'https://redirect.appmetrica.yandex.com/serve/604626520195011938'
      }

      switch (app) {
        case 'app-store':
          return 'https://app.adjust.com/14qq7d6g?deep_link=qatardrive%3A%2F%2Fmain&campaign=buy-policy-payment-success'
        case 'google-play':
          return 'https://app.adjust.com/14ldhhs0?deep_link=qatardrive%3A%2F%2Fmain&campaign=buy-policy-payment-success'
      }
    },
    hideNotification () {
      this.notificationShow = false
    },
    onReload () {
      this.$router.go()
    }
  }
}
</script>

<style lang="scss">
.whollwin{
  padding: 24px;
  background: url(./../assets/images/www.png) no-repeat center right/contain, linear-gradient(90deg, #FF3C6A 0%, #6218AC 100%);
  border-radius: 24px;
  margin-top: 20px;
  @media (max-width: 550px){
    background: url(./../assets/images/www-mobile.png) no-repeat center right/contain, linear-gradient(90deg, #FF3C6A 0%, #6218AC 100%);
  }
  &__top{
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    @media(max-width: 550px){
      svg{
        height: 22px;
        width: 55.43px;
        position: relative;
        top: 3px;
      }
    }
    p{
      font-size: 24px;
      line-height: 32px;
      color: #FFFFFF;
      margin-inline-start: 8px;
      font-weight: 600;
    }
  }
  &__desc{
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
    margin-bottom: 24px;
    @media (max-width: 550px){
      font-size: 14px;
      line-height: 24px;
    }
  }
  &__btn{
    width: 148px;
    height: 56px;
    background: #FFFFFF;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #FA344A;
    transition: .2s;
    &:hover{
      opacity: .9;
    }
  }
}
.rtl{
  .whollwin{
    background: url(./../assets/images/www-ar.png) no-repeat center left/contain, linear-gradient(-90deg, #FF3C6A 0%, #6218AC 100%);
    @media (max-width: 550px){
      background: url(./../assets/images/www-mobile-ar.png) no-repeat center left/contain, linear-gradient(-90deg, #FF3C6A 0%, #6218AC 100%);
    }
  }
}
.qd-app {
  .btn, a.btn {
    height: 72px;
  }
  h1 {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 32px;
    line-height: 40px;
  }
  .insuranceSendMail {
    max-width: 80%;
    margin: 0px auto 24px;
    padding: 0px;
    background: transparent;
    div {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: #1C1C1C;
    }
  }
  .info {
    margin-bottom: 24px;
    padding: 16px 30px;
    background: #FFFFFF;
    border: 1px solid #F2F4F7;
    border-radius: 12px;
    &__header {
      margin-bottom: 4px;
      font-weight: 500;
      font-size: 20px;
      line-height: 32px;
      text-align: center;
      color: #1C1C1C;
      &_mobile {
        max-width: 80%;
        margin: 0px auto 16px;
      }
    }
    &__desc {
      margin-bottom: 16px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
      color: rgba(57, 75, 90, 0.8);
    }
    &__links {
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        flex-shrink: 0;
        margin-inline-end: 16px;
      }
      img {
        width: auto;
      }
    }
    &__google-play, &__app-store {
      img, svg {
        height: 40px;
      }
    }
    &__qr {
      padding: 16px;
      background: #F1F4F6;
      border-radius: 15px;
      margin-inline-end: 16px;
      svg {
        width: 96px;
        height: 96px;
      }
    }
  }
  .btnInsSuc {
    min-width: 100%;
    margin-top: 0px;
  }
  .btn-ghost {
    min-width: 100%;
  }
  .paymentForm {
    padding: 56px 24px 68px;
  }
  @media (max-width: 767px) {
    background: #fff;
    .stepQuote {
      margin: 0px;
      .paymentForm {
        margin-top: 0px;
      }
    }
    &::after, .stepQuote {
      background: #fff;
    }
    .btn, a.btn {
      height: 54px;
      font-weight: 600;
      font-size: 17px;
      line-height: 22px;
    }
    h1 {
      font-weight: 600;
      font-size: 22px;
      line-height: 28px;
    }
    .insuranceSendMail {
      max-width: 80%;
      margin: 0px auto 20px;
    }
    .info {
      margin-bottom: 20px;
      background: #F1F4F6;
      &__header {
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
      }
      &__desc {
        font-size: 16px;
        line-height: 21px;
        color: #1C1C1C;
      }
      &__qr {
        display: none;
      }
    }
    .btn-ghost {
      background: #FFFFFF;
      border: 2px solid #F1F4F6;
      border-radius: 15px;
      font-weight: 600;
      font-size: 17px;
      line-height: 22px;
      letter-spacing: -0.408px;
      color: #1C1C1C;
    }
    .paymentForm {
      padding: 56px 16px 68px;
    }
  }
}
</style>
